module.exports = __webpack_public_path__ + "img/home_page.8c398951.jpg";